import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MODULE_NOT_IN_PLAN_MESSAGE } from "@/modules/moduleAccess";
import { buildConfiguracionRenovacionUrl } from "@/modules/config/configuracionRoutes";

/**
 * Pantalla de bloqueo cuando un deep link exige entitlement no contratado (Fase 3F-B).
 */
export default function RouteModuleEntitlementBlocked() {
  const navigate = useNavigate();

  return (
    <div
      className="flex min-h-[50vh] items-center justify-center p-8"
      data-testid="route-entitlement-blocked"
    >
      <div className="max-w-lg w-full rounded-md border border-slate-200 bg-white p-8 shadow-sm text-center space-y-4">
        <h2 className="text-lg font-semibold text-[#0F2D5C]">Módulo no disponible en su plan</h2>
        <p className="text-sm text-slate-600 leading-relaxed">{MODULE_NOT_IN_PLAN_MESSAGE}</p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
          <Button
            type="button"
            variant="outline"
            className="rounded-sm"
            asChild
          >
            <Link to="/">Volver al Panel General</Link>
          </Button>
          <Button
            type="button"
            className="rounded-sm bg-[#0F2D5C] hover:bg-[#0a2248]"
            onClick={() => navigate(buildConfiguracionRenovacionUrl())}
          >
            Solicitar habilitación
          </Button>
        </div>
      </div>
    </div>
  );
}
